import React, { Component } from 'react'
import clsx from 'clsx'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import PropTypes from 'prop-types'
import {
  CssBaseline, CircularProgress, Container, Button, Grid,
  Typography, Card, CardContent, Chip, IconButton,
  Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions
} from '@mui/material'
import { withStyles } from '@mui/styles'
import { Styles } from '../../styles/material-styles'
import { Overlay } from '../../styles/global'
import CustomizedSnackbars from '../../components/material-snackbars'
import HeaderMenu from '../../components/header-menu'
import Footer from '../../components/footer'
import { FormattedMessage, injectIntl } from 'react-intl'
import { AbilityContext } from '../../config/ability-context'
import Api from '../../services/api'
import AddIcon from '@mui/icons-material/Add'
import CreditCardIcon from '@mui/icons-material/CreditCard'
import DeleteIcon from '@mui/icons-material/Delete'
import StarIcon from '@mui/icons-material/Star'
import StarBorderIcon from '@mui/icons-material/StarBorder'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import { Link } from 'react-router-dom'
import StripeCardFormDialog from '../../components/stripe-card-form'
import {
  getPaymentMethods, createSetupIntent,
  setDefaultPaymentMethod, deletePaymentMethod
} from '../../services/billing.service'
import * as componentActions from '../../redux/actions/organizations'
import './index.css'

class BillingPaymentMethods extends Component {
  constructor(props) {
    super(props)

    this.state = {
      loading: false,
      openNotification: false,
      notificationVariant: 'error',
      notificationMessage: '',
      paymentMethods: [],
      addCardDialogOpen: false,
      clientSecret: null,
      deleteDialogOpen: false,
      deleteTarget: null
    }

    this.closeNotification = this.closeNotification.bind(this)
  }

  async componentDidMount() {
    await this.loadPaymentMethods()
  }

  async loadPaymentMethods() {
    const { userSession } = this.props
    const hirerId = userSession.user.hirerid
    if (!hirerId) return

    this.setState({ loading: true })
    try {
      const result = await getPaymentMethods(hirerId)
      if (result && result.data && result.data.success && Array.isArray(result.data.data)) {
        this.setState({ paymentMethods: result.data.data, loading: false })
      } else {
        this.setState({ paymentMethods: [], loading: false })
      }
    } catch (err) {
      this.setState({ paymentMethods: [], loading: false })
    }
  }

  handleAddCard = async () => {
    const { userSession } = this.props
    const intl = this.props.intl
    const hirerId = userSession.user.hirerid

    this.setState({ loading: true })
    const result = await createSetupIntent(hirerId)
    if (result && result.data && result.data.data && (result.data.data.clientsecret || result.data.data.clientSecret)) {
      this.setState({
        clientSecret: result.data.data.clientsecret || result.data.data.clientSecret,
        addCardDialogOpen: true,
        loading: false
      })
    } else {
      this.setState({
        loading: false,
        openNotification: true,
        notificationVariant: 'error',
        notificationMessage: intl.formatMessage({ id: 'billing.error.setup.intent' })
      })
    }
  }

  handleCardAdded = async () => {
    const intl = this.props.intl
    this.setState({ addCardDialogOpen: false, clientSecret: null })
    // Aguardar webhook processar (breve delay)
    setTimeout(async () => {
      await this.loadPaymentMethods()
      this.setState({
        openNotification: true,
        notificationVariant: 'success',
        notificationMessage: intl.formatMessage({ id: 'billing.card.added.success' })
      })
    }, 2000)
  }

  handleCardError = (errorMsg) => {
    this.setState({
      openNotification: true,
      notificationVariant: 'error',
      notificationMessage: errorMsg
    })
  }

  handleSetDefault = async (paymentMethodId) => {
    const { userSession } = this.props
    const intl = this.props.intl
    const hirerId = userSession.user.hirerid

    this.setState({ loading: true })
    const result = await setDefaultPaymentMethod(hirerId, paymentMethodId)
    if (result && result.data && result.data.success) {
      await this.loadPaymentMethods()
      this.setState({
        openNotification: true,
        notificationVariant: 'success',
        notificationMessage: intl.formatMessage({ id: 'billing.default.changed' })
      })
    } else {
      this.setState({
        loading: false,
        openNotification: true,
        notificationVariant: 'error',
        notificationMessage: result.data && result.data.errors && result.data.errors[0]
          ? result.data.errors[0]
          : intl.formatMessage({ id: 'process.error' })
      })
    }
  }

  handleDeleteClick = (pm) => {
    this.setState({ deleteDialogOpen: true, deleteTarget: pm })
  }

  handleDeleteConfirm = async () => {
    const { userSession } = this.props
    const intl = this.props.intl
    const hirerId = userSession.user.hirerid
    const pm = this.state.deleteTarget

    this.setState({ deleteDialogOpen: false, deleteTarget: null, loading: true })
    const result = await deletePaymentMethod(hirerId, pm.gatewaypaymentmethodid || pm.gatewayPaymentMethodId)
    if (result && result.data && result.data.success) {
      await this.loadPaymentMethods()
      this.setState({
        openNotification: true,
        notificationVariant: 'success',
        notificationMessage: intl.formatMessage({ id: 'billing.card.removed' })
      })
    } else {
      this.setState({
        loading: false,
        openNotification: true,
        notificationVariant: 'error',
        notificationMessage: result.data && result.data.errors && result.data.errors[0]
          ? result.data.errors[0]
          : intl.formatMessage({ id: 'process.error' })
      })
    }
  }

  closeNotification() {
    this.setState({ openNotification: false })
  }

  getCardBrandLabel(brand) {
    if (!brand) return 'Card'
    const brands = {
      'visa': 'Visa',
      'mastercard': 'Mastercard',
      'amex': 'American Express',
      'elo': 'Elo',
      'hipercard': 'Hipercard',
      'discover': 'Discover',
      'diners': 'Diners Club'
    }
    return brands[brand.toLowerCase()] || brand
  }

  render() {
    const { classes, headerMenu, actionsHeaderMenu } = this.props
    const intl = this.props.intl

    if (Api == null) {
      var l = this.props.match.params.lang
      document.location.href = `/${l}/unavailable`
    }

    return (
      <div className={classes.root} style={{ paddingLeft: 0, marginLeft: 0 }}>
        <HeaderMenu />
        <main
          className={clsx(classes.content, {
            [classes.contentShift]: headerMenu.open
          }, classes.actionsContent, {
            [classes.actionscontentShift]: actionsHeaderMenu.open,
          })}>
          <div className={classes.drawerHeader} />
          <Container component='main' maxWidth='md' style={{ paddingTop: 20 }}>
            <CssBaseline />

            <Grid container spacing={2} alignItems="center" style={{ marginBottom: 20 }}>
              <Grid item>
                <Button
                  component={Link}
                  to={`/${this.props.match.params.lang}/my-plan`}
                  startIcon={<ArrowBackIcon />}
                  color="primary"
                >
                  {intl.formatMessage({ id: 'back' })}
                </Button>
              </Grid>
              <Grid item xs>
                <Typography variant="h5" component="h1">
                  {intl.formatMessage({ id: 'billing.payment.methods' })}
                </Typography>
              </Grid>
              <Grid item>
                <Button
                  variant="contained"
                  color="primary"
                  startIcon={<AddIcon />}
                  onClick={this.handleAddCard}
                >
                  {intl.formatMessage({ id: 'billing.add.card' })}
                </Button>
              </Grid>
            </Grid>

            {this.state.paymentMethods.length === 0 && !this.state.loading && (
              <Card>
                <CardContent style={{ textAlign: 'center', padding: 40 }}>
                  <CreditCardIcon style={{ fontSize: 64, color: '#bdbdbd', marginBottom: 16 }} />
                  <Typography variant="body1" color="textSecondary">
                    {intl.formatMessage({ id: 'billing.no.payment.methods' })}
                  </Typography>
                </CardContent>
              </Card>
            )}

            {this.state.paymentMethods.map((pm) => (
              <div key={pm.id} className={`payment-method-card ${(pm.isdefault || pm.isDefault) ? 'default' : ''}`}>
                <div className="payment-method-info">
                  <CreditCardIcon style={{ fontSize: 32, color: (pm.isdefault || pm.isDefault) ? '#1976d2' : '#757575' }} />
                  <div>
                    <Typography variant="subtitle1" style={{ fontWeight: (pm.isdefault || pm.isDefault) ? 600 : 400 }}>
                      {this.getCardBrandLabel(pm.cardbrand || pm.cardBrand)} **** {pm.cardlast4 || pm.cardLast4}
                    </Typography>
                    <Typography variant="body2" color="textSecondary">
                      {intl.formatMessage({ id: 'billing.expires' })} {pm.cardexpmonth || pm.cardExpMonth}/{pm.cardexpyear || pm.cardExpYear}
                    </Typography>
                  </div>
                  {(pm.isdefault || pm.isDefault) && (
                    <Chip
                      label={intl.formatMessage({ id: 'billing.default' })}
                      color="primary"
                      size="small"
                      icon={<StarIcon />}
                    />
                  )}
                </div>
                <div className="payment-method-actions">
                  {!(pm.isdefault || pm.isDefault) && (
                    <Button
                      size="small"
                      startIcon={<StarBorderIcon />}
                      onClick={() => this.handleSetDefault(pm.gatewaypaymentmethodid || pm.gatewayPaymentMethodId)}
                    >
                      {intl.formatMessage({ id: 'billing.set.default' })}
                    </Button>
                  )}
                  <IconButton
                    size="small"
                    color="error"
                    onClick={() => this.handleDeleteClick(pm)}
                  >
                    <DeleteIcon />
                  </IconButton>
                </div>
              </div>
            ))}

          </Container>

          {/* Dialog para confirmar remoção */}
          <Dialog
            open={this.state.deleteDialogOpen}
            onClose={() => this.setState({ deleteDialogOpen: false, deleteTarget: null })}
          >
            <DialogTitle>{intl.formatMessage({ id: 'billing.remove.card.title' })}</DialogTitle>
            <DialogContent>
              <DialogContentText>
                {intl.formatMessage({ id: 'billing.remove.card.confirm' })}
                {this.state.deleteTarget && (
                  <strong> {this.getCardBrandLabel(this.state.deleteTarget.cardbrand || this.state.deleteTarget.cardBrand)} **** {this.state.deleteTarget.cardlast4 || this.state.deleteTarget.cardLast4}</strong>
                )}
                ?
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={() => this.setState({ deleteDialogOpen: false, deleteTarget: null })} color="primary">
                {intl.formatMessage({ id: 'cancel' })}
              </Button>
              <Button onClick={this.handleDeleteConfirm} color="error" variant="contained">
                {intl.formatMessage({ id: 'delete' })}
              </Button>
            </DialogActions>
          </Dialog>

          {/* Dialog Stripe para adicionar cartão */}
          <StripeCardFormDialog
            open={this.state.addCardDialogOpen}
            onClose={() => this.setState({ addCardDialogOpen: false, clientSecret: null })}
            clientSecret={this.state.clientSecret}
            onSuccess={this.handleCardAdded}
            onError={this.handleCardError}
          />

          {this.state.loading && (
            <Overlay>
              <CircularProgress color='secondary' />
            </Overlay>
          )}

          <CustomizedSnackbars
            variant={this.state.notificationVariant}
            message={this.state.notificationMessage}
            isOpen={this.state.openNotification}
            toClose={this.closeNotification}
          />

        </main>
        <Footer />
      </div>
    )
  }
}

BillingPaymentMethods.propTypes = {
  classes: PropTypes.object.isRequired
}

const mapStateToProps = state => ({
  actionsHeaderMenu: state.actionsHeaderMenu,
  headerMenu: state.headerMenu,
  userSession: state.userSession,
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(componentActions, dispatch)

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(withStyles(Styles)(BillingPaymentMethods)))

BillingPaymentMethods.contextType = AbilityContext
